import React, { useEffect, useState } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  selectedRowsState,
  demoModeState,
  inspStatusFilterState,
  queryOptionsState,
  selectedButtonState,
  selectedMenuState,
  totalCountState,
} from "../../recoil/index.ts";
import { CircularProgress } from "@mui/material";
import { CustomDataGrid } from "../CustomDataGrid.js";
import {
  getInspStatus,
  streamInspStatusCount,
} from "../../services/inspectService.js";
import { extractFullFileName, formatDate } from "../../utils/util.js";
export default function InspStatusTable({
  setOpenModal,
  setUuid,
  uuid,
  setTableData,
  receivedData,
  setReceivedData,
  setCount,
  setPageData,
  setCurrentPage,
  isFilterReset,
  setIsFilterReset,
  queryOption,
  setQueryOption,
}) {
  const [totalItems, setTotalItems] = useRecoilState(totalCountState);
  const setSelectedMenu = useSetRecoilState(selectedMenuState);
  const setSelectedButton = useSetRecoilState(selectedButtonState);
  const [filterOption, setFilterOption] = useRecoilState(inspStatusFilterState);
  // const [queryOption, setQueryOption] = useRecoilState(queryOptionsState);
  const [isLoading, setIsLoading] = useState(true);
  const [demoMode, setDemoMode] = useRecoilState(demoModeState);
  const [responseData, setResponseData] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowsData, setSelectedRowsData] =
    useRecoilState(selectedRowsState);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await getInspStatus({
        ...queryOption,
        ...filterOption,
      });
      const extractedData = response.data.contents.map((inspStatusData) => ({
        ...inspStatusData,
        file_name: extractFullFileName(inspStatusData.path),
        create_at: formatDate(inspStatusData.create_at),
      }));
      // if (!extractedData || extractedData.length === 0) {
      //   return;
      // }
      setReceivedData(extractedData);
      // setResponseData(response.data);
      setPageData(response.data);
      setCurrentPage(response.data.page);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    console.log("queryOption", queryOption);
    fetchData();
  }, [queryOption, filterOption]);

  useEffect(() => {
    if (!isFilterReset) return;
    fetchData();
    setIsFilterReset(false);
  }, [isFilterReset]);

  useEffect(() => {
    const eventSource = streamInspStatusCount(
      filterOption,
      (count) => {
        setTotalItems(count);
        setCount(count);
      },
      (finalCount) => {
        console.log("최종 카운트:", finalCount);
        setCount(finalCount);
      },
      (err) => {
        console.error("SSE 에러:", err);
      }
    );

    return () => {
      eventSource.close();
    };
  }, [filterOption]);

  useEffect(() => {
    // fetchData();
    setSelectedMenu("검사현황");
    setSelectedButton("검사현황");

    // cleanup
    return () => {
      setSelectedRows([]);
      setSelectedRowsData([]);
    };
  }, []);

  useEffect(() => {
    const safeRows = Array.isArray(receivedData) ? receivedData : [];
    setTableData(safeRows);
  }, [receivedData, setTableData]);

  let columns = [];

  if (demoMode) {
    columns = [
      { field: "id", headerName: "No.", width: 100 },
      { field: "client_ip", headerName: "Client Ip", width: 200 },
      { field: "name", headerName: "Name", width: 300 },
      { field: "material_name", headerName: "Material", width: 250 },
      { field: "lot", headerName: "Lot", width: 130 },
      { field: "label", headerName: "Label", width: 130 },
      { field: "create_at", headerName: "Date", width: 200 },
    ];
  } else {
    columns = [
      { field: "id", headerName: "No.", width: 100 },
      { field: "client_ip", headerName: "Client Ip", width: 200 },
      { field: "name", headerName: "Name", width: 200 },
      { field: "material_name", headerName: "Material", width: 250 },
      { field: "lot", headerName: "Lot", width: 130 },
      { field: "label", headerName: "Label", width: 130 },
      { field: "create_at", headerName: "Date", width: 200 },
    ];
  }

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
        }}
      >
        <CircularProgress style={{ color: "var(--text-color)" }} />
      </div>
    );
  }

  // if (!isLoading && receivedData && receivedData.length === 0) {
  //   return (
  //     <div
  //       style={{
  //         height: "80vh",
  //         display: "flex",
  //         alignItems: "center",
  //         justifyContent: "center",
  //         color: "var(--text-color)",
  //         opacity: 0.8,
  //       }}
  //     >
  //       데이터가 없습니다.
  //     </div>
  //   );
  // }

  const handleDetailClick = (params) => {
    setUuid(params.uuid);
    setOpenModal(true);
  };
  return (
    <CustomDataGrid
      rows={receivedData}
      uuid={uuid}
      columns={columns}
      checkboxSelection
      onRowClick={(params) => handleDetailClick(params.row)}
      onRowSelectionModelChange={(selectedIds) => {
        setSelectedRows(selectedIds);
        // 선택된 id들에 해당하는 전체 row 데이터 찾기
        const selectedRowData = selectedIds.map((id) => {
          const row = receivedData.find((row) => row.id === id);
          return {
            id: row.id,
            path: row.path,
          };
        });
        setSelectedRowsData(selectedRowData);
      }}
      rowSelectionModel={selectedRows}
    />
  );
}
